/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Videos_DownloadInputs */

const en_settings_videos_download = /** @type {(inputs: Settings_Videos_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download`)
};

/**
* | output |
* | --- |
* | "Download" |
*
* @param {Settings_Videos_DownloadInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_videos_download = /** @type {((inputs?: Settings_Videos_DownloadInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Videos_DownloadInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_videos_download(inputs)
});
export { settings_videos_download as "settings.videos.download" }